import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { useFetchGroupsAnalyticsQuery } from '../../../../../../../store/apis/analytics.api'
import { Spin } from 'antd'

export const GROUPS_STUDENT_KEYS = { ALL: 'all', CURRENT: 'current' }
export const GROUPS_DEFAULT_STUDENT_KEY = GROUPS_STUDENT_KEYS.CURRENT
export const GROUPS_DEFAULT_COMPONENT_INDEX = 0

const GroupsPie = ({ token, selectedComponentIndex = 0, selectedStudentKey = GROUPS_DEFAULT_STUDENT_KEY }) => {
    const { data: analytics, isFetching } = useFetchGroupsAnalyticsQuery({ token })

    const data =
        analytics &&
        analytics[selectedStudentKey][selectedComponentIndex]?.groups.map(group => ({
            group: group.name,
            percentOfStudents: group.percentOfStudents,
            numberOfStudents: group.numberOfStudents,
            value: group.numberOfStudents,
        }))

    const chartData = data || []

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']

    const renderCustomizedLabel = ({ index }) => {
        const item = chartData[index]
        return `${item.group} - ${item.percentOfStudents}%`
    }

    // Generate a detailed description of the data for accessibility
    const generateDescription = () => {
        if (!data) return 'Loading data...'
        let description = ''
        if (analytics?.numberOfStudents)
            description += `Total number of students: ${analytics.numberOfStudents} students. `
        if (analytics?.numberOfAllStudents)
            description += `Total number of all students: ${analytics.numberOfAllStudents} students. `
        description += 'Detailed breakdown of student groups: '
        data.forEach(item => {
            if (item.numberOfStudents === 0) return
            description += `${item.group} consists of ${item.numberOfStudents} students, making up ${item.percentOfStudents}% of the total. `
        })
        return description
    }

    return (
        <Spin spinning={isFetching} tip='Loading groups analytics...'>
            <div
                role='img'
                aria-label='Pie chart showing the distribution of student groups'
                aria-describedby={`groupsChartDescription-${token}`}
            >
                <ResponsiveContainer width='100%' height={400}>
                    <PieChart>
                        <Pie
                            data={chartData}
                            dataKey='value'
                            nameKey='group'
                            cx='50%'
                            cy='50%'
                            outerRadius={150}
                            innerRadius={100}
                            paddingAngle={2}
                            label={renderCustomizedLabel}
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip
                            formatter={(value, name, props) => {
                                const item = props.payload
                                return [`${item.percentOfStudents}% - ${item.numberOfStudents} students`, item.group]
                            }}
                        />
                    </PieChart>
                </ResponsiveContainer>
                <div id={`groupsChartDescription-${token}`} className='visually-hidden' tabIndex='0'>
                    {generateDescription()}
                </div>
            </div>
        </Spin>
    )
}

export default GroupsPie
